<template>
  <div class="container" v-if="online_pay">
    <div class="mwow-top-title">
      <span class="text">收款记录</span>
    </div>
    <el-form size="mini" :model="searchInfo" inline>
      <el-form-item label="收款时间：" prop="time">
        <!-- <el-date-picker
          v-model="searchInfo.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleSearch"
          value-format="yyyy-MM-dd"
          :clearable="false"
        >
        </el-date-picker> -->
        <common-date-range-selector
          v-model="searchInfo.time"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          @change="handleSearch"
          value-format="yyyy-MM-dd"
          :clearable="false"
        >
        </common-date-range-selector>
      </el-form-item>
      <el-form-item label="">
        <div class="flex-box">
          <el-select
            v-model.number="searchInfo.dynamicParams1.key"
            placeholder="请选择"
            @change="
              () => {
                searchInfo.dynamicParams1.value = '';
              }
            "
          >
            <el-option label="订单号" value="biz_id"></el-option>
            <el-option label="支付订单号" value="order_no"></el-option>
          </el-select>
          <el-input
            v-model="searchInfo.dynamicParams1.value"
            placeholder="请输入"
            @change="handleSearch"
            clearable
            maxlength="999"
          ></el-input>
        </div>
      </el-form-item>
      <el-form-item label="学员：" prop="student_id">
        <el-select
          v-model.number="searchInfo.student_id"
          filterable
          clearable
          placeholder="请输入学员姓名或手机号"
          @clear="handleSearchStudent('')"
          :filter-method="handleSearchStudent"
          @change="handleSearch"
        >
          <el-option
            v-for="item in studentList"
            :key="item.student_id"
            :label="item.name"
            :value="item.student_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付渠道：" prop="payment_channel">
        <el-select
          v-model.number="searchInfo.payment_channel"
          clearable
          placeholder="请选择"
          @change="handleSearch"
        >
          <el-option label="微信支付" :value="1"></el-option>
          <el-option label="支付宝支付" :value="2"></el-option>
          <!-- <el-option label="POS机支付" :value="4"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="入账状态：" prop="settle_status">
        <el-radio-group
          v-model="searchInfo.settle_status"
          @change="handleSearch"
        >
          <el-radio-button :label="-1">全部</el-radio-button>
          <el-radio-button :label="1">已入账</el-radio-button>
          <el-radio-button :label="2">未入账</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <!-- <el-form-item label="">
        <div class="flex-box">
          <el-select
            v-model.number="searchInfo.dynamicParams2.key"
            clearable
            placeholder="请选择"
            @change="()=>{
              searchInfo.dynamicParams2.min = '';
              searchInfo.dynamicParams2.max = '';
            }"
          >
            <el-option label="收款金额" :value="1"></el-option>
            <el-option label="退款金额" :value="2"></el-option>
            <el-option label="未到账金额" :value="3"></el-option>
            <el-option label="已到账金额" :value="4"></el-option>
          </el-select>
          <el-input
            v-model="searchInfo.dynamicParams2.min"
            placeholder="请输入"
            @change="handleSearch"
            clearable
            type="number"
          ></el-input>
          <span class="mid-text">至</span>
          <el-input
            v-model="searchInfo.dynamicParams2.max"
            placeholder="请输入"
            @change="handleSearch"
            clearable
            type="number"
          ></el-input>
        </div>
      </el-form-item> -->
    </el-form>
    <div style="margin-bottom: 12px">
      <div
        class="mwow-button-filled success"
        @click="handleExport"
        v-debounce="1000"
      >
        导出
      </div>
    </div>
    <el-table
      class="mwow-table"
      v-horizontal-scroll
      size="mini"
      :data="tableData"
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column
        label="收款时间"
        prop="trade_time"
        width="150px"
      ></el-table-column>
      <el-table-column
        label="收款金额(元)"
        prop="trade_amount"
        min-width="100px"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.trade_amount">{{ scope.row.trade_amount }}</div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="手续费金额" prop="fee_amount" min-width="100px">
        <template slot-scope="scope">
          -{{ scope.row.fee_amount ? scope.row.fee_amount : "-" }}
        </template>
      </el-table-column>
      <el-table-column
        label="服务费金额"
        prop="wow_fee_amount"
        min-width="100px"
      >
        <template slot-scope="scope">
          -{{ scope.row.wow_fee_amount ? scope.row.wow_fee_amount : "-" }}
        </template>
      </el-table-column>
      <el-table-column
        label="实际收入金额"
        prop="settle_amount"
        min-width="100px"
      >
        <template slot-scope="scope">
          {{ scope.row.settle_amount ? scope.row.settle_amount : "-" }}
        </template>
      </el-table-column>
      <el-table-column
        label="已退款金额(元)"
        prop="refund_amount"
        min-width="100px"
      >
        <template slot-scope="scope">{{ scope.row.refund_amount }} </template>
      </el-table-column>
      <el-table-column label="支付渠道" prop="provider_type">
        <template slot-scope="scope">
          {{ handleProviderType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="支付学员" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.student.student_id">
            <p>{{ scope.row.student.name }}</p>
            <p>{{ scope.row.student.mobile }}</p>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column label="订单号" prop="biz_id" width="200">
        <template slot-scope="scope">
          <div
            style="color: #07d1aa; cursor: pointer"
            @click="toOrderDetail(scope.row)"
          >
            {{ scope.row.biz_id ? scope.row.biz_id : "-" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="支付订单号"
        prop="order_no"
        width="230"
      ></el-table-column>
      <!-- <el-table-column label="入账状态" prop=""></el-table-column> -->
      <!-- <el-table-column label="到账时间" prop=""></el-table-column> -->
      <!-- <el-table-column label="备注" prop="remark"></el-table-column> -->
      <el-table-column label="入账" prop="settle_status">
        <template slot-scope="scope">
          <span v-if="scope.row.settle_status === 1">已入账</span>
          <span v-else>未入账</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110px">
        <template slot-scope="scope">
          <div
            class="mwow-button success"
            v-if="Number(scope.row.refund_amount) > 0"
            @click="showRefundDialog(scope.row)"
          >
            退款明细
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 统计 -->
    <div class="table-total-wrap">
      <div class="item">
        时间：<span class="green"
          >{{ searchInfo.time[0] }} - {{ searchInfo.time[1] }}</span
        >
      </div>
      <div class="item">
        总收款金额：<span class="green">{{ totalData.total }}</span
        >元
      </div>
      <div class="item">
        已入账 - 收款金额：<span class="green">{{ totalData.receive }}</span
        >元
      </div>
      <div class="item">
        未入账 - 收款金额：<span class="green">{{ totalData.waiting }}</span
        >元
      </div>
    </div>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>

    <el-dialog
      title="退款明细"
      :visible.sync="refundDialogVisible"
      @close="hideRefundDialog"
    >
      <div class="table-wrap">
        <div class="th">
          <div class="td">退款时间</div>
          <div class="td">退款金额</div>
          <div class="td">备注</div>
        </div>

        <div class="tr" v-for="item in refundData" :key="item.refund_order_id">
          <div class="td">{{ item.refund_time }}</div>
          <div class="td">{{ item.refund_amount }}</div>
          <div class="td">{{ item.remark }}</div>
        </div>
      </div>
    </el-dialog>
  </div>
  <div class="container container-loading" v-else-if="!online_pay">
    <div class="bg-block">
      <div class="info">
        <img
          src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/notOpen.png"
          alt=""
        />
        <div class="text">还未开通乐沃收银</div>
      </div>
      <div class="buttons">
        <div class="btn" @click="toStoreWallet">立即开通</div>
      </div>
    </div>
  </div>
</template>
<script>
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import {
  getOrderCollectionListApi,
  exportOrderCollectionListApi,
  refundDetailApi,
  getOrderCollectionStatisticsApi,
} from "@/api/order";
import { searchStudent } from "@/api/globalSearch";
import { UserModule } from "@/store/module/user";
import { PageModule } from "@/store/module/page";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        dynamicParams1: {
          key: "biz_id",
          value: "",
        },
        time: [],
        settle_status: -1,
      },
      studentList: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      refundDialogVisible: false,
      refundData: [],
      student: {
        page: 1,
        page_size: 50,
        total: 0,
      },
      totalData: {
        total: 0,
        receive: 0,
        waiting: 0,
      },
      online_pay: false,
    };
  },

  created() {
    this.online_pay = UserModule.userInfo.online_pay;
    // 从 vuex 中获取页面缓存数据
    const searchListInfo = PageModule.pageInfo.financialPaymentRecord;
    if (searchListInfo.page) {
      this.page = searchListInfo.page;
    }
    if (searchListInfo.page_size) {
      this.pageSize = searchListInfo.page_size;
    }
    if (this.online_pay) {
      let now = new Date().getTime();
      this.searchInfo.time = [
        dateFormat("YYYY-mm-dd", now - 365 * 24 * 60 * 60 * 1000),
        dateFormat("YYYY-mm-dd", now),
      ];
      this.handleSearchStudent("");
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 100,
        key_word: v || "",
      }).then((res) => {
        if (res.error_code === 0) {
          this.student.total = res.data.total;
          this.studentList = res.data.list;
        }
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.time && this.searchInfo.time.length >= 0) {
        option.trade_start_time = this.searchInfo.time[0];
        option.trade_end_time = this.searchInfo.time[1];
      }
      if (this.searchInfo.dynamicParams1.value) {
        if (this.searchInfo.dynamicParams1.key === "biz_id") {
          option.biz_id = this.searchInfo.dynamicParams1.value;
        }
        if (this.searchInfo.dynamicParams1.key === "order_no") {
          option.order_no = this.searchInfo.dynamicParams1.value;
        }
      }
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.payment_channel) {
        option.provider_type = this.searchInfo.payment_channel;
      }
      if (this.searchInfo.settle_status >= 0) {
        option.settle_status = this.searchInfo.settle_status;
      }
      getOrderCollectionListApi(option).then((res) => {
        if (res.error_code === 0) {
          this.page = res.data.page;
          this.total = res.data.total;
          res.data.list.map((item) => {
            item.trade_time =
              item.trade_time === 0
                ? "-"
                : dateFormat("YYYY-mm-dd HH:MM", item.trade_time * 1000);
          });
          this.tableData = res.data.list;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
      getOrderCollectionStatisticsApi(option).then((res) => {
        if (res.error_code === 0) {
          this.totalData = {
            total: Number(
              (
                Number(res.data.settle_complete_amount) +
                Number(res.data.settle_wait_amount)
              ).toFixed(2)
            ),
            receive: res.data.settle_complete_amount,
            waiting: res.data.settle_wait_amount,
          };
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    // 默认获取一年的订单
    getNowYear() {
      let date = new Date();
      let now = Date.now();
      let yearTimestamp = 366 * 24 * 60 * 60 * 1000; // 一年的时间戳，需要再多一天（精准）
      let yearDate = new Date(now - yearTimestamp);

      let startYear = yearDate.getFullYear();
      let startMonth = String(yearDate.getMonth() + 1).padStart(2, "0");
      let startDay = String(yearDate.getDate()).padStart(2, "0");

      let endYear = date.getFullYear();
      let endMonth = String(date.getMonth() + 1).padStart(2, "0");
      let endDay = String(date.getDate()).padStart(2, "0");
      // 回显创建时间查询
      this.searchInfo.time = [
        `${startYear}-${startMonth}-${startDay}`,
        `${endYear}-${endMonth}-${endDay}`,
      ];
    },
    toStoreWallet() {
      this.$router.push({
        name: "storeWallet",
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    showRefundDialog(row) {
      refundDetailApi({ pay_order_no: row.biz_id }).then((res) => {
        if (res.error_code === 0) {
          this.refundDialogVisible = true;
          res.data.list.map((item) => {
            item.refund_time =
              item.refund_time === 0
                ? "-"
                : dateFormat("YYYY-mm-dd HH:MM", item.refund_time * 1000);
          });
          this.refundData = res.data.list;
        }
      });
    },
    hideRefundDialog() {
      this.refundDialogVisible = false;
    },
    handleExport() {
      const option = {};
      if (this.searchInfo.time && this.searchInfo.time.length >= 0) {
        option.trade_start_time = this.searchInfo.time[0];
        option.trade_end_time = this.searchInfo.time[1];
      }
      if (this.searchInfo.dynamicParams1.value) {
        if (this.searchInfo.dynamicParams1.key === "biz_id") {
          option.biz_id = this.searchInfo.dynamicParams1.value;
        }
        if (this.searchInfo.dynamicParams1.key === "order_no") {
          option.order_no = this.searchInfo.dynamicParams1.value;
        }
      }
      if (this.searchInfo.student_id) {
        option.student_id = this.searchInfo.student_id;
      }
      if (this.searchInfo.payment_channel) {
        option.provider_type = this.searchInfo.payment_channel;
      }
      exportOrderCollectionListApi(option).then((res) => {
        if (res.error_code !== 0) {
          return this.$message.warning({
            message: res.message,
          });
        }
        exportLoop(res.data.task_id);
      });
    },
    handleProviderType(row) {
      if (row.provider_type === 1) {
        return "微信";
      } else if (row.provider_type === 2) {
        return "支付宝";
      } else {
        return "-";
      }
    },
    // 缓存需要的数据
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "financialPaymentRecord",
        key: "search_info",
        value: this.searchInfo,
      });
      PageModule.SET_PAGE_INFO({
        name: "financialPaymentRecord",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "financialPaymentRecord",
        key: "page_size",
        value: this.pageSize,
      });
    },
    toOrderDetail(row) {
      // 跳转前，将 searchInfo、page 数据缓存，等返回时使用
      sessionStorage.setItem(
        "paymentRecord",
        JSON.stringify("financial_paymentRecord")
      );
      this.cachePageInfo();
      this.$router.push({
        name: "orderManageDetail",
        query: {
          ono: row.biz_id,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.container-loading {
  height: 80vh;
  .bg-block {
    text-align: center;
    margin-top: 28vh;
    .info {
      margin-bottom: 5px;
      img {
        width: 52px;
        height: 50px;
      }
      .text {
        font-size: 14px;
        margin: 11px 0;
      }
    }
    .buttons {
      .btn {
        margin: 0 auto;
        background: #07d1aa;
        color: white;
        width: 84px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 5px;
      }
      .btn:hover {
        cursor: pointer;
      }
    }
  }
}
.flex-box {
  display: flex;
  .el-select {
    flex: 3;
    margin-right: 8px;
  }
  .el-input {
    flex: 5;
    margin-right: 8px;
  }
  .mid-text {
    margin-right: 8px;
  }
}
.table-wrap {
  font-size: 12px;
  color: #5c5d5e;
  line-height: 42px;
  text-align: center;
  max-height: 500px;
  overflow: auto;
  .th {
    font-weight: 700;
  }
  .th,
  .tr {
    display: flex;
    justify-content: space-around;
    .td:nth-child(1) {
      flex: 1;
    }
    .td:nth-child(2) {
      flex: 1;
    }
    .td:nth-child(3) {
      flex: 1;
    }
  }
}
.table-total-wrap {
  background: #f8f8f8;
  display: flex;
  align-items: center;
  padding: 12px 0;
  .item {
    font-size: 12px;
    color: #5c5d5e;
    line-height: 16px;
    margin: 0 24px;
    white-space: nowrap;
    .green {
      color: #07d1aa;
    }
  }
}
</style>
